import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Mismo alto que los chips de etiqueta (24 px), con borde discontinuo para leerse como acción
export const AddTagButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 10px 0 8px;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${color.text.secondary};
  background: ${color.background.default};
  border: 1px dashed ${color.border.default};
  border-radius: 999px;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;

  :hover:not(:disabled),
  :focus-visible {
    color: ${props => props.theme.primary || color.brand.primary};
    border-color: ${props => props.theme.primary || color.brand.primary};
    outline: none;
  }

  :disabled {
    cursor: default;
    color: ${color.text.disabled};
  }
`

export const TagsMenu = styled.div`
  width: 260px;
  padding: 8px;

  .tags-list {
    max-height: 240px;
    overflow-y: auto;
    margin: 8px 0 0;
    padding: 0;
    list-style: none;

    li button {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
      padding: 8px;
      font-family: ${tokens.typography.fontFamily.primary};
      font-size: 13px;
      font-weight: 400;
      color: ${color.text.primary};
      text-align: left;
      background: transparent;
      border: 0;
      border-radius: 6px;
      cursor: pointer;

      :hover,
      :focus-visible {
        background: ${color.background.light};
        outline: none;
      }
    }

    .tag-dot {
      flex-shrink: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }

    .tag-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .empty {
      padding: 8px;
      font-size: 13px;
      color: ${color.text.tertiary};
    }
  }
`
